<div class="add-co-op-dialog-container">
    <div class="add-co-op-header-container">
        <div>  <p class="add-co-op-header-dialog-header-text add-co-op-section-headers">ADD CO-OP MEMBER NO</p></div>
        <div><p class="add-co-op-sub-heading">Add an additional co-op member number.</p></div>
    </div>

    <form [formGroup]="addCoOpForm">
        <div class="add-co-op-description-container">
            <mat-form-field class="add-co-op-input" appearance="outline">
                <mat-label>CO-OP Member NO</mat-label>
                <input matInput formControlName="newCoOpnumber">
            </mat-form-field>
        </div>

    </form>
    <div class="add-co-op-btn-dialog-container">

        <button class="add-co-op-btn-dialog-btn" mat-flat-button type="button" (click)="cancelAddingCoOP()">
            <div class="add-co-op-btn-content">
                <span><p class="add-co-op-alt-btn-text">CANCEL</p></span>
            </div>
        </button>

        <button class="apply-co-opp-btn" mat-flat-button type="button" (click)="addCoOpMember()">
            <div class="apply-co-op-btn-content">
                <span><p class="apply-co-op-btn-text">APPLY</p></span>
            </div>
        </button>
    </div>

</div>


